module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDEyIDYiPjxwYXRoIGZpbGw9IiMwMDczMmYiIGQ9Ik0wIDBoMTJ2MkgweiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDJoMTJ2MkgweiIvPjxwYXRoIGQ9Ik0wIDRoMTJ2MkgweiIvPjxwYXRoIGZpbGw9InJlZCIgZD0iTTAgMGgzdjZIMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/are.svg
// module id = l7H2
// module chunks = 0